import React, { useCallback, useEffect, useState } from "react";
import { SearchBar } from "./SearchBar";
import { TutorProfileRow } from "./TutorProfileRow";
import { CheckboxFilterCollection } from "./Filters/CheckboxFilterCollection";
import { FilterDictionary } from "./Types/FilterDictionary";
import { TutorRowProfile } from "../firestore/Types/UI/TutorRowProfile";
import { getAllTutorProfiles } from "../firestore/Functions/tutorProfileFunctions";
import { useUtility } from "../contexts/auth/UtilityContext";
import { getProfilePictureURL } from "../firebase/storage/ProfileFunctions";
import { useNavigate } from "react-router-dom";
import { ItemPair } from "../firestore/Types/UI/ItemPair";
import { getLoadingOpacity, Loading } from "./Utils/Loading";
import { AutoComplete } from "./AutoComplete";
import { useStudent } from "../contexts/auth/StudentContext";
export function TutorsSearchBox() {
    const navigate = useNavigate();
    
    const [allTutors, setAllTutors] = useState([] as TutorRowProfile[]);

    const [filteredTutors, setFilteredTutors] = useState([] as TutorRowProfile[]);

    const [searchValue, setSearchValue] = useState<string>('');

    const [schoolSearchValue, setSchoolSearchValue] = useState<string>('');

    const [filterDictionary, setFilterDictionary] = useState<FilterDictionary>({});

    const [isloading, setIsLoading] = useState(true);

    const [isSubscribed, setIsSubscribed] = useState(false);

    const { subjects, schools, schoolImages, setNewToast } = useUtility();

    const { stripeCustomerSubscriptions } = useStudent();

    useEffect(() => {
        setFilteredTutors(filterTutors(allTutors, searchValue, schoolSearchValue, filterDictionary));
    }, [searchValue, schoolSearchValue, filterDictionary, allTutors]);

    //enable when there are more users
    // useEffect(() => {
    //     setSchoolSearchValue(schools.find(school => school.Id === account.SchoolID)?.Name ?? "");
    // }, [account.SchoolID, schools]);

    useEffect(() => {
        setIsSubscribed((stripeCustomerSubscriptions?.length ?? 0) > 0);
    }, [stripeCustomerSubscriptions]);

    const setFilteredSubjects = (subjects: string[]) => {
        setFilterDictionary({...filterDictionary, subjects: subjects});
    }

    const handleSetSchoolFilter = (schoolId: string) => {
        const schoolName = schools.find(school => school.Id === schoolId)?.Name ?? "";
        setSchoolSearchValue(schoolName);
    }

    const setupPage = useCallback(async () => {
        setIsLoading(true);
        const tutorRowProfiles: TutorRowProfile[] = [];
        const profileImages: ItemPair[] = [];
        const profiles = await getAllTutorProfiles().catch((error) => {setNewToast({title: "Internal Error", message: error.message, toastType: "error"}); return []});

        for (let i = 0; i < profiles.length; i++) {
            const profile = profiles[i];
                
            var profileImage = await getProfilePictureURL(profile.Id);
            profileImages.push({
                Text: profile.Id,
                Value: profileImage
            } as ItemPair);

            tutorRowProfiles.push({
                id: profile.Id,
                name: profile.Name,
                subjects: profile.Subjects.map(subject => subjects.find(s => s.Id === subject.SubjectID)?.SubjectName ?? ""),
                tier: profile.TutorTier,
                school: schools.find(school => school.Id === profile.SchoolId)?.Name ?? "",
                schedule: profile.Schedule,
                profileImage: profileImage,
                schoolImage: schoolImages.find(school => school.SchoolId === profile.SchoolId)?.Image ?? "",
                sessions: 0,
            });
        }

        setAllTutors(tutorRowProfiles);
        setTimeout(() =>setIsLoading(false), 500);
    }, [setNewToast, subjects, schoolImages, schools]);

    useEffect(() => {
        setupPage();
    }, [setupPage]);
    
    return (
        <>
            <div className={"max-w-[950px] max-md:px-0 md:px-4 max-md:mx-0 max-xl:pt-6 md:mx-auto md:bg-white md:border border-t-0 border-b-0 relative " + getLoadingOpacity(isloading)}>
                <div className="grid md:grid-cols-10 max-md:grid-cols-1">
                    <div className=" md:col-span-3 max-md:col-span-1 flex flex-col">
                        <div className="border-solid border p-2 md:mx-2 mt-2 section-box">
                            <div className="at-header text-sm border-b-1 border border-l-0 border-t-0 border-r-0 mb-2">Filter</div>
                            <SearchBar setSearchValue={setSearchValue} />
                            <div className="m-2"/>
                            <CheckboxFilterCollection category="Subjects" constraints={subjects.map(subject => subject.SubjectName).sort()} setFilterValues={setFilteredSubjects} />
                            <hr className="m-2"></hr>

                            <div className="section-title text-base">School</div>
                            <AutoComplete Items={schools.map((school) => ({ Text: school.Name, Value: school.Id } as ItemPair))} value={schools.find(school => school.Id === "")?.Name ?? ""} setValue={handleSetSchoolFilter} />
                        </div>
                    </div>
                    <div className="grid mt-1 md:col-span-7 max-md:col-span-1 relative overflow-auto">
                        <ul>
                            {filteredTutors.map(( tutor, index ) => {return TutorProfileRow({tutor: tutor, key: index, isSubscribed: isSubscribed, navigate: navigate })})}
                        </ul>
                    </div>
                </div>
            </div>
            {isloading && <Loading />}
        </>
    );
}

function filterTutors(tutors: TutorRowProfile[], searchValue: string, schoolSearchValue: string, filterDictionary: FilterDictionary) {

    const subjectFilter = (s: string) => filterDictionary["subjects"].indexOf(s.toLowerCase()) > -1;
    return tutors.filter(tutor => {
        return tutor.name.toLowerCase().includes(searchValue.toLowerCase())
            && tutor.school.toLowerCase().includes(schoolSearchValue.toLowerCase())
            && ((filterDictionary["subjects"] && filterDictionary["subjects"].length > 0) ? tutor.subjects.some(subjectFilter) : true);
    });
}